import type { Market } from '@paulownia/shared';
import { DAY_OF_WEEK_LABELS } from '@paulownia/shared';

interface MarketHeaderProps {
  market: Market;
  merchantCount: number;
}

/**
 * Header component displaying market information
 */
export function MarketHeader({ market, merchantCount }: MarketHeaderProps) {
  const dayLabel = DAY_OF_WEEK_LABELS[market.dayOfWeek];

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold">{market.city}</h1>
      <p className="text-muted-foreground">
        {dayLabel} · {market.openingTime} - {market.closingTime}
      </p>
      {market.address && (
        <p className="text-sm text-muted-foreground mt-1">{market.address}</p>
      )}
      <p className="text-sm font-medium mt-2">
        {merchantCount} commercant{merchantCount > 1 ? 's' : ''}
      </p>
    </div>
  );
}
